<template>
    <Layout>
        <template slot="body">
            <Importacao title="Importar geração distribuida" modeloUrl="/assets/modelo_geracao_distribuida.xlsx" :success="success" :errors="errors" :uploading="uploading" @dados="sendFile"></Importacao>
        </template>
    </Layout>
</template>

<script>

    import Layout from "@/components/layout/Layout.vue";
    import Importacao from "@/components/importar/Importacao.vue";

    export default {
        data() {
            return {
                success: false,
                errors: null,
                uploading: false,
                data: {
                    file: null
                }
            }
        },
        methods: {
            sendFile(file) {
                this.data.file = JSON.stringify(file);
                this.success = false;
                this.errors = null;
                this.uploading = true;

                callAPI(
                    "/importacao/geracao-distribuida",
                    "post",
                    this.data,
                    (res) => {
                        if ( res.success ) {
                            this.success = true;
                            this.errors = null;
                        } else {
                            this.success = false;
                            this.errors = res.errors;
                        }

                        this.uploading = false;
                    }
                );
            }
        },
        components: {
            Layout,
            Importacao
        },
    };
</script>